<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon class="section-icon">contacts</mat-icon>
      <span i18n="@@Address Book">Address Book</span>
    </mat-panel-title>
    <mat-panel-description>
      <span *ngIf="addresses.length === 0" i18n="@@No saved addresses">No saved addresses</span>
      <span *ngIf="addresses.length === 1" i18n="@@1 saved address">1 saved address</span>
      <span *ngIf="addresses.length > 1">{{addresses.length}}&nbsp;<ng-container i18n="@@saved addresses">saved addresses</ng-container></span>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div class="settings-description" i18n="@@AddressBookDescription">Manage the shipping addresses available to you at checkout. The default address is auto-selected when you start a new order.</div>

  <!-- List of saved addresses -->
  <div class="address-book-list" *ngIf="addresses.length > 0">
    <div *ngFor="let address of addresses" class="address-book-row" [class.address-book-row-default]="address.default">
      <div class="address-book-block">
        <div class="address-book-name">
          <ng-container *ngIf="address.firstname">{{address.firstname}}&nbsp;</ng-container>
          <ng-container *ngIf="address.lastname">{{address.lastname}}</ng-container>
          <mat-icon *ngIf="address.default" class="address-book-default-icon" i18n-title="@@Default" title="Default">favorite</mat-icon>
        </div>
        <div *ngIf="address.company">{{address.company}}</div>
        <div>
          <ng-container *ngIf="address.address1">{{address.address1}}</ng-container>
          <ng-container *ngIf="address.address2">,&nbsp;{{address.address2}}</ng-container>
        </div>
        <div>
          <ng-container *ngIf="address.city">{{address.city}}</ng-container>
          <ng-container *ngIf="address.state">,&nbsp;{{address.state}}</ng-container>
          <ng-container *ngIf="address.postalcode">&nbsp;{{address.postalcode}}</ng-container>
          <ng-container *ngIf="address.country">&nbsp;{{address.country}}</ng-container>
        </div>
        <div *ngIf="address.email" class="address-book-meta">{{address.email}}</div>
      </div>
      <div class="address-book-actions">
        <button mat-icon-button *ngIf="!address.default" (click)="makeDefault(address)" i18n-title="@@Make default" title="Make default"><mat-icon>favorite_border</mat-icon></button>
        <button mat-icon-button (click)="startEdit(address)" i18n-title="@@Edit" title="Edit"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button (click)="deleteAddress(address)" i18n-title="destructive removal|Button that permanently destroys the record. Must be clearly different from Cancel, which only closes a dialog.@@Delete" title="Delete"><mat-icon>delete</mat-icon></button>
      </div>
    </div>
  </div>

  <div class="address-book-empty" *ngIf="addresses.length === 0 && !editingAddress">
    <span i18n="@@No addresses yet — add one below.">No addresses yet — add one below.</span>
  </div>

  <!-- Add / Edit form (inline) -->
  <div class="address-book-form-wrap" *ngIf="editingAddress">
    <h3 class="settings-heading">
      <ng-container *ngIf="editingIsNew" i18n="@@Add new address">Add new address</ng-container>
      <ng-container *ngIf="!editingIsNew" i18n="@@Edit address">Edit address</ng-container>
    </h3>
    <form class="section-form">
      <div class="form-row">
        <mat-form-field appearance="outline" class="flex-field">
          <mat-label i18n="@@First Name">First Name</mat-label>
          <input matInput name="firstname" [(ngModel)]="editingAddress.firstname" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-field">
          <mat-label i18n="@@Last Name">Last Name</mat-label>
          <input matInput name="lastname" [(ngModel)]="editingAddress.lastname" required>
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="full-field">
        <mat-label i18n="@@Company">Company</mat-label>
        <input matInput name="company" [(ngModel)]="editingAddress.company">
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-field">
        <mat-label i18n="@@Street Address">Street Address</mat-label>
        <input matInput name="address1" [(ngModel)]="editingAddress.address1" required>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-field">
        <mat-label i18n="@@Apt/Suite">Apt/Suite</mat-label>
        <input matInput name="address2" [(ngModel)]="editingAddress.address2">
      </mat-form-field>
      <div class="form-row">
        <mat-form-field appearance="outline" class="flex-field">
          <mat-label i18n="@@City">City</mat-label>
          <input matInput name="city" [(ngModel)]="editingAddress.city" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-field-sm">
          <mat-label i18n="@@State">State</mat-label>
          <mat-select name="state" [(ngModel)]="editingAddress.state" required>
            <mat-option *ngFor="let s of usStates" [value]="s.code">{{s.name}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-field-sm">
          <mat-label i18n="@@Zip Code">Zip Code</mat-label>
          <input matInput name="postalcode" [(ngModel)]="editingAddress.postalcode" required>
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="full-field">
        <mat-label i18n="@@Country">Country</mat-label>
        <mat-select name="country" [(ngModel)]="editingAddress.country" required>
          <mat-option *ngFor="let c of countries" [value]="c.code">{{c.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-field">
        <mat-label i18n="@@Email">Email</mat-label>
        <input matInput name="email" type="email" [(ngModel)]="editingAddress.email" required>
      </mat-form-field>
      <mat-slide-toggle color="primary" name="default" [(ngModel)]="editingAddress.default">
        <ng-container i18n="@@Make this my default address">Make this my default address</ng-container>
      </mat-slide-toggle>

      <div class="address-book-form-actions">
        <button mat-stroked-button type="button" (click)="cancelEdit()" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
        <button mat-raised-button color="primary" type="button" [disabled]="!isEditingComplete()" (click)="saveEdit()" i18n="@@Save">Save</button>
      </div>
    </form>
  </div>

  <!-- Add address CTA (shown when not currently editing) -->
  <div class="address-book-cta" *ngIf="!editingAddress">
    <button mat-raised-button color="primary" (click)="startAddNew()">
      <mat-icon>add</mat-icon>&nbsp;<ng-container i18n="@@Add address">Add address</ng-container>
    </button>
  </div>
</mat-expansion-panel>
